import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-134" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-135" data-mp="3ggaqfufcyb4x">
        <p className="font-serif text-3xl tracking-tight" data-id="element-136" data-mp="3ghc0pwojutll">
          ANGIELSKI GOTOWY<span className="align-super text-[0.5em]" data-id="element-137" data-mp="32pfh6h0y5s0t">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-138" data-mp="36oo5359b2vog">
          ANGIELSKI GOTOWY™ to niezależny materiał dydaktyczny, a nie oficjalny produkt Ministerstwa Edukacji Narodowej (MEN).
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-139" data-mp="37fvf8oqf24t">
          © 2026 ANGIELSKI GOTOWY™. Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}